<template>
  <BaseModal cardWidth="600px" noPadding noToolbar noExit @close="$emit('close')">
    <template #default>
      <!-- Modal Header -->
      <div class="relative w-full flex gap-2 p-5 border-b border-border-normal">
        <MCPIcon :width="18" :height="18" class="text-icon-muted flex-shrink-0" />
        <div class="flex-grow flex flex-col">
          <BaseText type="label" size="sm" class="text-text-muted">
            Connect MCP
          </BaseText>
          <BaseText type="body" size="sm" class="text-text-normal">
            Foreplay now supports MCP with OAuth.
          </BaseText>
          <!-- Platform Selector -->
          <div class="w-max flex items-center gap-0.5 p-0.5 rounded-lg bg-neutral-25 mt-4 overflow-hidden">
            <button v-for="platform in platforms" :key="`platform-options-${platform.key}`"
            class="platform-option-btn flex items-center px-1.5 py-1 rounded-md" :class="{'active': selectedPlatform === platform.key}"
            @click="selectedPlatform = platform.key">
              <img :src="platform.icon">
              <BaseText type="label" size="sm" class="text-text-muted px-1">
                {{ platform.label }}
              </BaseText>
            </button>
          </div>
          <!-- Close button -->
          <button class="absolute top-3 right-3 p-1 transition-opacity" @click="$emit('close')">
            <TagRemoveIcon stroke="#5E6678" :width="16" :height="16" />
          </button>
        </div>
      </div>
      <!-- Modal Content -->
      <div class="setup-content w-full px-5 pt-5 pb-10">
        <ClaudeMCPSetup v-if="selectedPlatform === 'claude'" class="fade-in" />
        <ChatGptMCPSetup v-if="selectedPlatform === 'chatgpt'" class="fade-in" />
      </div>
    </template>
  </BaseModal>
</template>

<script>
import MCPIcon from '../../globals/Icons/ApiIcons/MCPIcon.vue'
import TagRemoveIcon from '../../globals/Icons/TagRemoveIcon.vue'

import ClaudeMCPSetup from './ClaudeMCPSetup.vue'
import ChatGptMCPSetup from './ChatGptMCPSetup.vue'

export default {
  name: 'ConnectMCPModal',
  components: {
    MCPIcon,
    TagRemoveIcon,
    ClaudeMCPSetup,
    ChatGptMCPSetup
  },
  data () {
    return {
      selectedPlatform: 'claude',
      platforms: [
        { key: 'claude', label: 'Claude', icon: require('@/assets/icons/mcp-platforms/claude.svg') },
        { key: 'chatgpt', label: 'ChatGPT', icon: require('@/assets/icons/mcp-platforms/chatgpt.svg') },
      ]
    }
  }
}
</script>

<style scoped>
.platform-option-btn {
  background-color: transparent;
  box-shadow: none;
  transition: background-color 100ms ease-in-out, box-shadow 100ms ease-in-out;
}
.platform-option-btn:hover:not(.active) {
  background-color: #ECEFF3;
}
.platform-option-btn.active {
  background-color: white;
  box-shadow: 0 16px 16px -8px rgba(31, 35, 38, 0.02), 0 16px 16px -8px rgba(31, 35, 38, 0.02), 0 8px 8px -4px rgba(31, 35, 38, 0.02), 0 8px 8px -4px rgba(31, 35, 38, 0.02), 0 2px 2px -1px rgba(31, 35, 38, 0.02), 0 2px 2px -1px rgba(31, 35, 38, 0.02);
}

.setup-content ::v-deep .steps-container {
  display: grid;
  grid-template-columns: 28px minmax(0, 1fr);
  column-gap: 12px;
  row-gap: 20px;
}
.setup-content ::v-deep .step-number {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  width: 28px;
  height: 28px;
  padding: 4px;
  border-radius: 8px;
  color: #5C667A;
  border: 1px solid #ECEFF3;
}

.fade-in {
  animation: fadeIn 200ms ease-in-out;
}
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
</style>